import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: '山西鹭友科技有限公司-软件服务供应商'
    }
  },
  {
    path: '/list/:id',
    name: 'ListView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/ListView.vue'),
    meta: {
      title: '列表页'
    }
  },
  {
    path: '/article',
    name: 'ArticleDetail',
    component: () => import('../views/ArticleDetail.vue'),
    meta: {
      title: '文章详情'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to) => {
  // const title = to.meta && typeof to.meta.title === 'string' ? to.meta.title : '山西鹭友科技有限公司-软件服务供应商'
  const title = '山西鹭友科技有限公司-软件服务供应商'
  document.title = title // 默认标题
})

export default router
